<ng-container *transloco="let t">
  <div
    class="flex overflow-x-auto lg:overflow-hidden gap-3 lg:gap-0 lg:bg-surface-card lg:rounded-xl widget-no-scrollbar mb-6 lg:mb-8 pb-1 lg:pb-0"
  >
    @for (stat of statItems(); track stat.status) {
    <button
      (click)="onClick(stat.status)"
      class="widget-stat-item"
      [class.widget-stat-item--active]="selectedStatus() === stat.status"
    >
      <div class="widget-stat-icon" [class.widget-stat-icon--active]="selectedStatus() === stat.status">
        <mat-icon [svgIcon]="selectedStatus() === stat.status ? stat.iconActive : stat.iconInactive"></mat-icon>
      </div>
      <div class="flex flex-col items-start">
        <p
          class="widget-stat-count"
          [class.text-primary]="selectedStatus() === stat.status"
          [class.text-ink-secondary]="selectedStatus() !== stat.status"
        >
          {{ stat.count | translocoDecimal : { useGrouping: false } }}
        </p>
        <p
          class="widget-stat-label"
          [class.text-primary]="selectedStatus() === stat.status"
          [class.text-ink-muted]="selectedStatus() !== stat.status"
        >
          {{ t(stat.labelKey) }}
        </p>
      </div>
    </button>
    @if (!$last) {
    <div class="widget-stat-divider hidden lg:block"></div>
    } }
  </div>
</ng-container>
